import NYCTimesDashboardView from "src/sections/dashboards/platforms/nyc-times/nyc-times-dashboard-view";

const NYCTimesCustomDashboardPage = () => <NYCTimesDashboardView type="custom" />;

export default NYCTimesCustomDashboardPage;
